export default __webpack_public_path__ + "static/media/EM0670.34I-21940_-14962_0.7e6766e1.jpg";